import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1467b6a1&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1467b6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467b6a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1467b6a1')) {
      api.createRecord('1467b6a1', component.options)
    } else {
      api.reload('1467b6a1', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1467b6a1&scoped=true&", function () {
      api.rerender('1467b6a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qgF02LBOGV5d/JS/comp/GuestBox.vue"
export default component.exports